
  

       

        <div class="wrapper fadeInDown">
			<div id="formContent">
			  <form autocomplete="off" [formGroup]="formAdmin" (ngSubmit)="onSubmit(formAdmin.value)" >
  
		 <div [innerHtml]='qrGoogle'></div>

		  <div class="formGroup">
			<input type="password" class="formControl" autocomplete="new-password" formControlName="clave" placeholder="clave" #userPassword required>
		  </div>
	
		  <!-- Calling SignIn Api from AuthService -->
		  <div class="formGroup">
			<input type="submit" id="button" class="btn btnPrimary" value="Acceder">
		  </div>
	
		</form>
  
				  <!-- Remind Passowrd -->
	  <div id="formFooter">
		<a class="underlineHover" routerLink="/forgot-password">Olvidó su password?</a>
	  
		  <div class="redirectToLogin">
			<span>No tiene cuenta?</span><a class="underlineHover" [routerLink]="['/sign-in-user']"> Dar de alta servicio</a>
		  </div>
		  <div class="redirectToLogin">
			  <span style="color: red;">Fase Beta ¡¡Importante¡¡ SOLO PARA CHROME</span>
			</div>
  
			<div class="redirectToLogin">
			  <img src="../../../assets/img/chrome.png"  class="rounded-circle" width="60" height="60" alt="Navegador Imagen" />
			</div>
  
		  </div>
	  
	
		</div>
	  </div>
  
  
	  
	 <app-index></app-index>
